import React from "react";
import "./InnovationInPracticeSection.scss";
import ContentSection from "../components/ContentSection";
import SectionHeader from "../components/SectionHeader";
import TwoColumnLayout from "../components/TwoColumnLayout";
import AUTHOR_IMAGE from "../assets/images/abramowitz.png";

const InnovationInPracticeSection: React.FC = () => {
  const leftContent = (
    <div className="innovation-in-practice-section-content">
      <p>
        As someone who has spent years both behind the walls and in national
        leadership spaces, I’ve learned that data isn’t just about proving a
        point. It’s about building bridges. It’s about crafting a more just and
        fair world, one data point—and one person—at a time.
      </p>
      <p>
        Every piece of data tells a story. A line graph showing a drop in
        recidivism isn't just an abstract trend—it represents people who are
        coming home, finding jobs, supporting families, and breaking
        generational cycles. Let’s see what the data tells us. Research
        consistently shows that education and career-technical training are
        among the most effective tools for reducing recidivism and supporting
        successful reentry.
      </p>
      <p>
        A landmark RAND study found that incarcerated individuals who
        participated in educational programs had 43% lower odds of reoffending,
        and those who engaged in vocational training were 28% more likely to
        find employment after release (
        <a href="https://www.rand.org/pubs/research_reports/RR266.html">
          source
        </a>
        ).
      </p>
      <h4>From the Classroom to the Boardroom</h4>
      <p>
        The Petey Greene Program continues to collect and analyze data on
        participant outcomes, instructor performance, program completion rates,
        and post-release success. We use that data to adjust our programming,
        advocate for reform, and prove the transformative power of education
        behind bars. And just as importantly, we elevate the lived experience of
        our students and alumni—ensuring that the human stories behind the
        numbers remain front and center.
      </p>
    </div>
  );

  const rightContent = (
    <div className="innovation-in-practice-section-right-content">
      <img src={AUTHOR_IMAGE} alt="" className="author-image" />
    </div>
  );

  return (
    <ContentSection className="innovation-in-practice-section">
      <SectionHeader
        title="HIGHLIGHTS FROM THE FIELD"
        description="How Data Shaped My Journey from Reentry to Reform"
      />

      <div className="author-block">
        <p className="author-name">By Jeffrey Abramowitz</p>
        <p className="author-title">CEO, Pete Greene Program & Puttkammer</p>
        <p className="author-organization">Center for Educational Justice</p>
      </div>

      <TwoColumnLayout leftContent={leftContent} rightContent={rightContent} />
    </ContentSection>
  );
};

export default InnovationInPracticeSection;
